<script setup lang="ts">
import type { ArrowLinkProps } from '@/types/appTypes'

const props = withDefaults(defineProps<ArrowLinkProps>(), {
  label: '',
  bold: false,
})
</script>

<template>
  <div
    class="c-arrowLink"
  >
    <NuxtLink
      v-bind:to="to"
    >
      <v-icon class="c-arrowLink_icon">
        mdi-chevron-right
      </v-icon>
      <div
        class="c-arrowLink_label"
        v-bind:class="{ 'is-bold': bold }"
      >
        {{ label }}
      </div>
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.c-arrowLink {
  font-size: 14px;
  text-align: right;

  &_label {
    line-height: 2.286;
    white-space: nowrap;

    &.is-bold {
      font-weight: bold;
    }
  }

  > a {
    display: inline-flex;
    align-items: center;
    color: var(--color_primary_link);

    &:hover {
      text-decoration: none;

      .c-arrowLink_label {
        text-decoration: underline;
      }
    }

    :deep(.v-icon) {
      color: var(--color_primary_link);
    }
  }
}
</style>
